import { useEffect, useState } from "react";
import { useGlobalReducer } from "../../../GlobalContext";
import { GetBlacklistEntityAudits } from "../../api/entityService";
import { toDisplayDateTime } from "../../blocks/fields/formatDate";
import { RecordTable } from "../../blocks/layout/RecordTable";
import { RecordTableColumn } from "../../blocks/layout/RecordTable.types";
import { TablePagination } from "../../blocks/layout/TablePagination";
import { PageSizes } from "../../config/pageSizes";
import { Loading } from "../../elements/Loading";

type Audit = Record<string, unknown>;

// Type 3 is an unsuppress; the only other audit is a mail exclusion removal.
const UnsuppressAuditType = 3;

const columns: RecordTableColumn<Audit>[] = [
  { key: "Label", label: "Email address", width: 300 },
  {
    key: "Type",
    label: "Type",
    width: 200,
    accessor: (audit) =>
      audit.Type === UnsuppressAuditType
        ? "Unsuppress"
        : "Mail exclusion removal",
  },
  { key: "EmailAddress", label: "Modified By", width: 300 },
  {
    key: "CreatedOn",
    label: "Date",
    width: 200,
    accessor: (audit) => toDisplayDateTime(audit.CreatedOn as string),
  },
];

export function BlacklistAudits() {
  const globalDispatch = useGlobalReducer();
  const [audits, setAudits] = useState<Audit[] | null>(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PageSizes[0]);

  useEffect(() => {
    const load = async () => {
      try {
        const response = await GetBlacklistEntityAudits(globalDispatch);
        setAudits(response?.data ?? []);
      } catch (error) {
        console.error("Error fetching blacklist audits:", error);
        setAudits([]);
      }
    };
    load();
  }, [globalDispatch]);

  if (!audits) {
    return <Loading />;
  }

  const start = (page - 1) * pageSize;

  return (
    <>
      <RecordTable
        columns={columns}
        rows={audits.slice(start, start + pageSize)}
        emptyMessage="No email addresses have been unsuppressed or removed yet."
      />
      <TablePagination
        total={audits.length}
        page={page}
        pageSize={pageSize}
        pageSizeId="blacklist-audits-page-size"
        onPageChange={setPage}
        onPageSizeChange={(size) => {
          setPageSize(size);
          setPage(1);
        }}
      />
    </>
  );
}
